import { render, staticRenderFns } from "./vice-president.vue?vue&type=template&id=49d22218&scoped=true&"
import script from "./vice-president.vue?vue&type=script&lang=js&"
export * from "./vice-president.vue?vue&type=script&lang=js&"
import style0 from "./vice-president.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./vice-president.vue?vue&type=style&index=1&id=49d22218&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d22218",
  null
  
)

export default component.exports